<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: ImmersiveBackLink                                     |
| Section: components                                              |
| Purpose: Safe exit from full-screen route experiences.           |
+------------------------------------------------------------------+
-->
<template>
    <a class="immersive-back-link" :href="localePath('/')" @click.prevent="goBack">
        <img src="@/assets/icons/arrow-left.svg" alt="" />
        <span>{{ $t('nav.back') }}</span>
    </a>
</template>

<script>
import { useLocale } from '@/composables/useLocale';

export default {
    name: 'ImmersiveBackLink',
    setup() {
        const { localePath } = useLocale();
        return { localePath };
    },
    methods: {
        goBack() {
            const previousRoute = window.history.state?.back;
            if (typeof previousRoute === 'string' && previousRoute.startsWith('/')) {
                this.$router.back();
                return;
            }
            this.$router.push(this.localePath('/'));
        },
    },
};
</script>

<style scoped>
.immersive-back-link {
    position: fixed;
    top: max(24px, calc(env(safe-area-inset-top) + 12px));
    left: max(24px, calc(env(safe-area-inset-left) + 12px));
    z-index: 1400;
    display: inline-flex;
    min-height: 44px;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    border: 1px solid rgba(29, 29, 29, 0.08);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.16);
    backdrop-filter: blur(6px);
    color: var(--brand-text-dark);
    font-size: 0.8125rem;
    font-weight: 650;
    line-height: 1;
    text-decoration: none;
}

.immersive-back-link:hover,
.immersive-back-link:focus-visible {
    color: var(--brand-color-1);
    text-decoration: underline;
}

.immersive-back-link img {
    width: 16px;
    height: 16px;
}

@media (max-width: 768px) {
    .immersive-back-link {
        top: max(12px, calc(env(safe-area-inset-top) + 8px));
        left: max(12px, calc(env(safe-area-inset-left) + 8px));
        width: 44px;
        padding: 0;
        justify-content: center;
    }

    .immersive-back-link span {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
}
</style>
